import styled, { css } from 'styled-components';
import { fontFamily, colors } from 'components/styles/_variables';
import { respondTo } from '../../styles/_respondTo';

export const StyledTypography = styled.p`
  font-family: ${fontFamily.primary};
  color: ${({ color = 'grey' }) => colors.theme[color]};
  font-weight: ${({ variant }) => variant === 'title' ? 'bold' : 'normal' };
  font-size: ${({ variant }) => variant === 'title' ? '24px' : '14px' };
  margin-bottom: ${({ mb = 20 }) => `${mb}px`};
  margin-top: ${({ mt = 0 }) => `${mt}px`};
  text-align: ${({ textAlign }) => textAlign};
  ${({ ellipsis }) => ellipsis && css`
    overflow: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    max-width: 250px;
    ${respondTo.smallDesktop`
      max-width: 320px;
    `}
  `}
`;